import { useQuery } from '@tanstack/react-query';

import { sharedAccessApi } from '../api';

interface UseFriendsListParams {
  userId: string;
}

interface UseFriendsListQueryParams {
  queryKey: ['lifestack.friendsList', { userId: string }];
}

export const useFriendsList = ({ userId }: UseFriendsListParams) => {
  const friendsListQuery = useQuery({
    queryKey: ['lifestack.friendsList', { userId }],
    queryFn: ({ queryKey }: UseFriendsListQueryParams) => {
      const [, { userId }] = queryKey;

      return sharedAccessApi.getSharedAccessUsers(userId).then(({ data }) => data.users);
    },
    refetchOnWindowFocus: false,
    staleTime: 15 * 60 * 1000, // 15 minutes
    enabled: !!userId,
  });

  return {
    friendsList: friendsListQuery.data ?? [],
    ...friendsListQuery,
  };
};
